<template>
  <div class="form-row d-info d-frame">
    <p>
      Empik to jedna z najlepiej rozpoznawalnych polskich marek. Pomaga każdemu odkrywać i rozwijać pasje – niezależnie od tego czy to sport, literatura, ogród czy wystrój wnętrz.
      Daje najszerszy i kompleksowy wybór jakościowych produktów z wielu dziedzin – nie tylko książek, płyt, filmów, gier planszowych, biletów na wydarzenia, artykułów kreatywnych czy zabawek, ale również dodatkowo online: produktów i akcesoriów sportowych, do domu, elektronicznych i dla dzieci.
    </p>
    <p><a href="" @click.prevent="showMore = true" v-if="!showMore">więcej informacji</a></p>
    <div v-if="showMore">
      <p>E-karta jest możliwa do wykorzystania wyłącznie w Sklepie Internetowym empik.com na zakup towarów i usług, których Sprzedawcą jest Empik (produkty oznaczone opisem „oferta empik.com”).</p>
      <p>E-karta nie upoważnia Użytkownika do nabywania jakichkolwiek towarów lub usług oferowanych na empik.com przez podmioty inne niż Empik (nie można nią dokonać zapłaty za produkty sprzedawane przez inne podmioty w ramach Usługi
        Marketplace). Nie ma możliwości wymiany lub wydania nowej e-karty, jeśli zostanie ona zniszczona, zagubiona lub skradziona. Korzystanie z e-karty oznacza akceptację regulaminu
        kart prezentowych Empik dostępnego na <a href="https://media.empik.com/content/strony-specjalne/karty%20prezentowe/regulamin_karty_prezentowej.PDF" target="_blank" rel="nofollow">https://media.empik.com</a></p>
      <ul>
        <li>Wejdź na stronę <a href="https://www.empik.com" target="_blank" rel="nofollow">www.empik.com</a> i zaloguj się</li>
        <li>Wybierz produkty i dodaj je do koszyka</li>
        <li>Przy wyborze „sposób płatności” wybierz e-karta</li>
        <li>Wprowadź alfanumeryczny kod podany powyżej</li>
        <li>Jeśli wartość zakupów przekracza wartość e-karty wybierz drugą formę płatności</li>
        <li>Przejdź dalej i dokończ zakupy</li>
      </ul>
      <p>Kod ważny do 30.08.2023 r.</p>
      <p>W przypadku pytań prosimy o kontakt z działem obsługi klienta.</p>
      <p>Tel <a href="tel:48224627250">22 462 72 50</a></p>
      <p>Miłych zakupów na <a href="https://www.empik.com" target="_blank" rel="nofollow">empik.com</a></p>
      <p><a href="" @click.prevent="showMore = false">zwiń</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopupCodesInfoEmpikCard',
  data () {
    return {
      showMore: false
    }
  }
}
</script>
